import { Component, OnInit } from '@angular/core';
import { Travel } from 'src/app/models/travel';
import { NgbDateAdapter, NgbTimeAdapter, NgbTimepickerConfig, NgbModal, NgbTimeStruct, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TimeNativeAdapter } from 'src/app/adapters/native-time-adapter';
import { UnityService } from 'src/app/services/unity.service';
import { AuthService } from 'src/app/services/auth.service';
import { Unity } from 'src/app/models/unity';
import { User } from 'src/app/models/user';
import { Set } from 'src/app/models/set';
import { DriverService } from 'src/app/services/driver.service';
import { Driver } from 'src/app/models/driver';
import { TravelLine } from 'src/app/models/travel-line';
import { OrderService, OrderFilters } from 'src/app/services/order.service';
import { Order } from 'src/app/models/order';
import { Customer } from 'src/app/models/customer';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/product.service';
import { Product } from 'src/app/models/product';
import { PresentationsService } from 'src/app/services/presentations.service';
import { Presentation } from 'src/app/models/presentation';
import { TravelManager } from 'src/app/classes/travel-manager';
import { DatesManager } from 'src/app/classes/dates-manager';
import { CustomerAddress } from 'src/app/models/customer-address';
import { TravelRoute } from 'src/app/models/travel-route';
import { ExpenseService } from 'src/app/services/expense.service';
import { Expense } from 'src/app/models/expense';
import { TravelService } from 'src/app/services/travel.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { dir } from '../../route/route-create/route-create.component';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { TravelExpense } from 'src/app/models/travel-expense';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LogisticEventsService } from 'src/app/services/logistic-events.service';

@Component({
  selector: 'app-travel-create',
  templateUrl: './travel-create.component.html',
  styleUrls: ['./travel-create.component.css'],
  providers: [
    // {provide: NgbDateAdapter, useClass: NativeDateAdapter}, 
    // {provide: NgbTimeAdapter, useClass: TimeNativeAdapter},
    NgbTimepickerConfig
  ]
})
export class TravelCreateComponent implements OnInit {

  travel:Travel = new Travel();
  selectedLine:TravelLine = new TravelLine();
  travelLine:TravelLine = new TravelLine();
  travelLines:TravelLine[] = [];
  unities:Unity[];
  sets:Set[];
  setsAll:Set[];
  user:User;
  drivers:Driver[];
  loading:boolean = false;
  hasRoute:boolean = true;
  orders:Order[] = [];
  customers:Customer[] = []
  products:Product[] = [];
  presentations:Presentation[] = [];
  showAddLiner: boolean = true;
  customer:Customer;
  customerAddress:CustomerAddress;
  product:Product;
  presentation:Presentation;
  routes:TravelRoute[] = [];
  casetas:Expense[] = [];
  caseta:Expense;
  combustibles:Expense[] = [];
  combustible:Expense;
  actualUser:string = "";
  cash:number = 0;
  origin:dir = {
    lat: 0,
    lng: 0,
  };
  target:dir = {
    lat: 0,
    lng: 0,
  };
  renderOptions = {
    draggable: true,
  }
  totAxis = 0;
  travelRoutes = [];
  minDate: any;

  deliveryDate: NgbDateStruct;  
  deliveryTime: NgbTimeStruct; 

  prdDate: NgbDateStruct;
  prdTime: NgbTimeStruct; 

  gasDate: NgbDateStruct;
  gasTime: NgbTimeStruct; 
  pendingEvent: any = null;
  dateErrorMsg = '';
  showError = false;
  arrastre1:Unity[];
  arrastre2:Unity[];
  arrastre3:Unity[];
  arrastre3B:Unity[];
  arrastre1Disabled = true;
  arrastre2Disabled = true;
  arrastre3Disabled = true;

  constructor(
    private unityServ:UnityService, private auth:AuthService, private driverServ:DriverService, config: NgbTimepickerConfig, 
    private orderServ:OrderService, private modalService: NgbModal, private customerServ:CustomerService, private productServ:ProductService, 
    private presenServ:PresentationsService, private travelManager:TravelManager, private expServ:ExpenseService, private travelServ:TravelService, 
    private utl:UtilitiesService, private toastr: ToastrManager, private logisticEv:LogisticEventsService, private dtsMgr : DatesManager
  ) { 
    this.setInitDates();
    config.spinners = false;
    this.actualUser = auth.getActualUser().name + " " + auth.getActualUser().last_name;
  }

  ngOnInit() {
    this.loading = true;
    this.unityServ.getUnities().then(unities => {
      this.unities = unities;
      this.setArrastres(unities);
      this.travel.unity = null;
      this.travel.trailer_1 = null;
      this.travel.trailer_2 = null;
      this.travel.trailer_3 = null;
      this.loading = false;
    });
    this.driverServ.getDrivers(true).then(drivers => {
      this.drivers = drivers;
      this.travel.helper_1 = null;
      this.travel.helper_2 = null;
      this.travel.operator = this.drivers[0];
    });
    this.unityServ.getSets().then(sets => this.setsAll = sets);
    this.productServ.getProducts().then(products => {
      this.products = products;
      this.product = this.products[0];
    });
    this.presenServ.getPresentations().then(presentations => {
      this.presentations = presentations;
      this.presentation = this.presentations[0];
    });
    this.user = this.auth.getActualUser();
    this.customerServ.getCustomers().then(customers => {
      this.customers = customers
      this.customer = customers[5];
      this.customerAddress = customers[5].directions[0];
    });
    this.expServ.getExpenses("type", "Viaje").then(expenses => {
      this.casetas = expenses.filter(exp => exp.expense_type.name == 'Casetas');
      this.caseta = this.casetas[0];
      this.combustibles = expenses.filter(exp => exp.expense_type.name == 'Combustible');
      this.combustible = this.combustibles[0];
    })
  }

  save(event) {
    
    event.preventDefault();
    this.travel.delivery_date = this.combine(this.deliveryDate, this.deliveryTime);
    this.travel.prd_loading_date = this.combine(this.prdDate, this.prdTime);
    this.travel.gas_loading_date = this.combine(this.gasDate, this.gasTime);

    //verificar por cada linea que no sobrepase el total de combustible en cantidades
    //verificar que al menos una línea tenga un producto y presentación diferente a cargar diversas y vacios
    let viajesNoVacios = 0;
    for (let i = 0; i < this.travel.lines.length; i++) {
      let total = this.travel.lines[i].travelExpenses
        .filter(exp => exp.expense_type_name == 'Combustible' && exp.travel_line_id == this.travel.lines[i].id)
        .map(exp => exp.quantity)
        .reduce((anterior, actual) => Number(anterior) + Number(actual), 0);

      if (total > Number(this.travel.lines[i].gas)) {
        this.toastr.infoToastr("No se puede exceder el total de disel en la linea: " + (i + 1));
        return;
      }

      viajesNoVacios += this.travel.lines[i].presentation_name == 'Vacio' ? 0 : 1;
    }

    if (!viajesNoVacios) {
      this.toastr.infoToastr("El viaje debe tener por lo menos un artículo");
      return;
    }

    this.loading = true;

    this.travel.unity_id = this.travel.unity.id;
    this.travel.trailer_1_id = this.travel.trailer_1 ? this.travel.trailer_1.id : null;
    this.travel.trailer_2_id = this.travel.trailer_2 ? this.travel.trailer_2.id : null;
    this.travel.trailer_3_id = this.travel.trailer_3 ? this.travel.trailer_3.id : null;

    this.travel.operator_id = this.travel.operator ? this.travel.operator.id : null;
    this.travel.helper_1_id = this.travel.helper_1 ? this.travel.helper_1.id : null;
    this.travel.helper_2_id = this.travel.helper_2 ? this.travel.helper_2.id : null;

    for(let i = 0; i < this.travel.lines.length; i++) {
      let line = this.travel.lines[i];
      if (line.order_id == 0) {
        line.order_id = null;
      }
    }
    
    this.travelServ.postTravel(this.travel)
      .then(res => {
        this.toastr.successToastr('Creado correctamente con el NO: ' + res.id);
        this.loading = false;
        this.logisticEv.sendTravelCreated(res);

        this.travel = new Travel();
        this.selectedLine = new TravelLine();
        this.travelLine = new TravelLine();
        this.travelLines = [];
        this.hasRoute = true;
        this.showAddLiner = true;
        this.routes = [];
        this.cash = 0;
        this.travel.operator = this.drivers[0];
        this.travel.unity = this.unities[0];

        if (!res.contracted) {
          window.open("/travel/gasticket/" + res.id, "_blank");
        }
      })
      .catch(e => {
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(e), 'Oops!', { enableHTML: true });
      });
  }

  showOrders(modal) {
    let filters:OrderFilters = {
      status: 'Creada',
      date1: null,
      date2: null,
      user: null,
    }
    this.loading = true;
    this.orderServ.getOrders(filters).then(orders => {
      this.orders = orders;
      this.modalService.open(modal, { size: 'lg' });
      this.loading = false;
    });
  }

  selectOrder(ord:Order) {
    if (ord.id != 0 && this.travelLines.find(line => ord.id == line.order_id)) {
      this.toastr.infoToastr("orden ya seleccionada, escoger otra");
      return;
    }

    this.travelLine = {
      delivery_date: new Date(ord.delivery_date),
      gas: 0,
      meters: 0,
      ton: ord.ton,
      travelExpenses: [],
      order_id: ord.id,
      presentation_id: ord.presentation_id,
      presentation_name: ord.presentation.name,
      product_id: ord.product_id,
      product_name: ord.product.name,
      target_customer: ord.customer.name,
      target_customer_id: ord.customer_id,
      target_customer_address: ord.customer_address.name,
      target_customer_address_id: ord.customer_address_id,
      time: 0,
      unit_type_presentation: ord.unit_type_presentation,
      source_customer: this.travelLines.length ? this.travelLine.source_customer : ord.source_customer.name,
      source_customer_id: this.travelLines.length ? this.travelLine.source_customer_id : ord.source_customer_id,
      source_customer_address: this.travelLines.length ? this.travelLine.source_customer_address : ord.source_customer_address.name,
      source_customer_address_id: this.travelLines.length ? this.travelLine.source_customer_address_id : ord.source_customer_address_id,
      travel_id: 0,
      id: 0,
      line: this.travelLines.length,
      hasExpenses: false,
      gas_extra: 0,
      ticket: 0,
      ton_real: 0,
      num_lines: 1,
      market_price: this.travelLine.market_price
    };

    this.travel.description = (this.travel.description ? this.travel.description + ", " : '') + "Pedido " + ord.id + ": " + ord.description;

    this.getRoutesByAddress((route) => {
      this.addline();
      this.routes.push(route);
    });
    
  }

  addline() {
    if (this.travelLine.product_name != 'Cargas Diversas' && this.travelLine.presentation_name == 'Vacio') {
      this.toastr.infoToastr('No puedes agregar la linea con la presentación vacio!');
      return;
    }
    if (this.travelLine.product_name == 'Cargas Diversas' && this.travelLine.presentation_name != 'Vacio') {
      this.toastr.infoToastr('Cargas Diversas solo debe llevar vacio!');
      return;
    }
    if (this.travelLine.ton == 0 && this.travelLine.product_name != 'Cargas Diversas') {
      this.toastr.infoToastr('No se puede agregar un articulo con peso 0!');
      return;
    }
    
    if((this.travelLine.delivery_date && this.travelLine.gas && this.travelLine.meters && this.travelLine.presentation_id && this.travelLine.presentation_name && this.travelLine.product_id && this.travelLine.product_name && this.travelLine.source_customer && this.travelLine.source_customer_address && this.travelLine.source_customer_address_id && this.travelLine.source_customer_id && this.travelLine.target_customer && this.travelLine.target_customer_address && this.travelLine.target_customer_address_id && this.travelLine.target_customer_id && this.travelLine.time && this.travelLine.unit_type_presentation) || (this.travel.contracted && this.travelLine.delivery_date && this.travelLine.presentation_id && this.travelLine.presentation_name && this.travelLine.product_id && this.travelLine.product_name && this.travelLine.source_customer && this.travelLine.source_customer_address && this.travelLine.source_customer_address_id && this.travelLine.source_customer_id && this.travelLine.target_customer && this.travelLine.target_customer_address && this.travelLine.target_customer_address_id && this.travelLine.target_customer_id && this.travelLine.unit_type_presentation)) {
      
      if(this.travelLine.order_id != 0){
        this.travel.sale_order_id = this.travelLine.order_id; 
      }      
      this.travelLine.line = this.travelLines.length;
      this.travelLine.meters = this.travelLine.meters * this.travelLine.num_lines;
      this.travelLines.push(Object.assign({}, this.travelLine));
      this.travelLine = new TravelLine();

      this.setSource();

      this.hasRoute = true;
      return true;
    } else {
      this.toastr.infoToastr("Todos los datos son necesarios");
      return false;
    }
  }
  
  removeLine(ln:TravelLine) {
    if (ln.line == this.travelLines[this.travelLines.length - 1].line) {
      this.travelLines = this.travelLines.filter(line => line != ln);
      this.setSource();
    } else {
      this.toastr.infoToastr('Solo se puede eliminar la ultima ruta');
    }
  }

  setSource() {
    this.travelLine.source_customer = this.travelLines[this.travelLines.length - 1].target_customer;
    this.travelLine.source_customer_id = this.travelLines[this.travelLines.length - 1].target_customer_id;
    this.travelLine.source_customer_address = this.travelLines[this.travelLines.length - 1].target_customer_address;
    this.travelLine.source_customer_address_id = this.travelLines[this.travelLines.length - 1].target_customer_address_id;
  }

  showModal (modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  showModalSet (modal) {
    this.sets = this.setsAll.filter(set => set.contracted == this.travel.contracted);
    this.modalService.open(modal, { size: 'lg' });
  }

  selectSet (set:Set) {
    if (this.travel.contracted != set.contracted) {
      this.toastr.infoToastr("Para viajes contratados solo puede elejir a contratistas y para viajes no contratados solo unidades locales");
    } else {
      this.travel.set_id = set.id;
      this.travel.unity = this.unities.find(unity => unity.id == set.truck_id);
      this.travel.trailer_1 = this.unities.find(unity => unity.id == set.trailer_1_id);
      this.travel.trailer_2 = this.unities.find(unity => unity.id == set.trailer_2_id);
      this.travel.trailer_3 = this.unities.find(unity => unity.id == set.trailer_3_id);
      this.travel.operator = this.drivers.find(driver => driver.id == set.operator_id);
      this.travel.helper_1 = this.drivers.find(driver => driver.id == set.helper_1_id);
      this.travel.helper_2 = this.drivers.find(driver => driver.id == set.helper_2_id);

      this.calcTotAxis();
    }
  }

  calcExpenses() {
    const checkarrastres = this.verifArrastres();
    if (checkarrastres[0]) {
      this.toastr.errorToastr(checkarrastres[1], 'Oops!', { enableHTML: true });
      return;
    }

    //validar que haya escogido por lo menos una unidad
    if (!this.travel.set_id) {
      this.toastr.infoToastr("No se ha seleccionado un conjunto");
      return;
    }
    
    //validar que minimo existan dos lineas
    if ( this.travelLines.length < 2 ) {
      this.toastr.infoToastr("Selecciona dos o mas líneas, incluyendo el viaje de regreso");
      return;
    }

    //verrificar si existe un regreso y preguntar si desea seguir
    if ( this.travelLines[0].source_customer_id != this.travelLines[this.travelLines.length - 1].target_customer_id || this.travelLines[0].source_customer_address_id != this.travelLines[this.travelLines.length - 1].target_customer_address_id ) {
      if (!confirm('Estás seguto que deseas agregar el viaje sin el regreso?')) {
        return;
      }
    }

    this.loading = true;

    //calc expenses
    this.travel.gas_total = 0;
    this.cash = 0;
    //NOTE: Modifica Fecha
    let orderDates = this.travelLines.filter(x => x.order_id).map(x => x.delivery_date);
    // this.travel.delivery_date = new Date(Math.min.apply(null, orderDates));
    const delivery_date = new Date(Math.min.apply(null, orderDates));
    this.deliveryDate = {
      year: delivery_date.getFullYear(),
      month: delivery_date.getMonth() + 1,
      day: delivery_date.getDate()
    };

    this.deliveryTime = {
      hour: delivery_date.getHours(),
      minute: delivery_date.getMinutes(),
      second: 0
    };

    // this.travel.prd_loading_date = new Date(this.dtsMgr.calcProductDate(this.travel.delivery_date.getTime(), this.travelLines.map(x => x.time).reduce((x, y) => x + y, 0)));
    // this.travel.gas_loading_date = new Date(this.dtsMgr.calcGasDate(this.travel.prd_loading_date.getTime()));
    //NOTE: NO DESCOMENTAR
    // let date = this.travel.delivery_date;
    // this.travel.gas_loading_date = new Date(date.getFullYear(),date.getMonth(),(date.getDate()-1));

    for (let i = 0; i < this.travelLines.length; i++) {
      for(let j = 0; j < this.routes.length; j++) {
        if( this.routes[j].source_customer_address_id == this.travelLines[i].source_customer_address_id && this.routes[j].target_customer_address_id == this.travelLines[i].target_customer_address_id ) {
          this.travelLines[i].travelExpenses = this.travelManager.getExpenses(this.routes[j], 
            this.travel.unity,
            this.travel.trailer_1,
            this.travel.trailer_2,
            this.travel.trailer_3,
          );
          this.travelLines[i].hasExpenses = true;

          for( let k = 0; k < this.travelLines[i].travelExpenses.length; k++) {
            if (this.travelLines[i].travelExpenses[k].expense_type_name == 'Combustible') {
              this.travelLines[i].travelExpenses[k].quantity = this.travelLines[i].gas;
            }
          }

          //SI ES GASOLINA CAMBIAR EL DIESEL POR GASOLINA
          if (this.travel.unity.gas_type == 'Gasolina') {
            for (let k = 0; k < this.travelLines[i].travelExpenses.length; k++) {
              let exp:TravelExpense = this.travelLines[i].travelExpenses[k];
              if (exp.expense_name == 'SUPER DIESEL') {
                let expLocal = this.combustibles.find(comb => comb.name == 'EXTRA GASOLINA');

                exp.expense_id = expLocal.id;
                exp.expense_name = expLocal.name;
                exp.expense_type = expLocal.expense_type.type;
                exp.expense_type_id = expLocal.expense_type_id;
                exp.expense_type_name = expLocal.expense_type.name;
              }
              if (exp.expense_name == 'DIESEL FORANEO') {
                let expLocal = this.combustibles.find(comb => comb.name == 'GASOLINA FORANEA');

                exp.expense_id = expLocal.id;
                exp.expense_name = expLocal.name;
                exp.expense_type = expLocal.expense_type.type;
                exp.expense_type_id = expLocal.expense_type_id;
                exp.expense_type_name = expLocal.expense_type.name;
              }
            }
          }
        }
      }

      //calc combustible
      this.travel.gas_total += Number(this.travelLines[i].gas);
      //calc monto
      for (let j = 0; j < this.travelLines[i].travelExpenses.length; j++) {
        this.cash += Number(this.travelLines[i].travelExpenses[j].price);
      }
      //fecha menor
      
      //NOTE: Modifica Fecha
      // if ( this.travel.delivery_date > this.travelLines[i].delivery_date) {
      //   this.travel.delivery_date = this.travelLines[i].delivery_date;
      // }
    }

    this.travel.lines = this.travelLines;
    this.loading = false;
    this.showAddLiner = false;

  }

  selectline(ln:TravelLine) {
    this.selectedLine = ln;
  }

  selectSourceCustomer () {
    if (this.customer && this.customerAddress) {
      this.travelLine.source_customer = this.customer.name;
      this.travelLine.source_customer_id = this.customer.id;
      this.travelLine.source_customer_address = this.customerAddress.name;
      this.travelLine.source_customer_address_id = this.customerAddress.id;
      this.getMarketPriceByRoute(); //Obtenemos el precio de mercado si es ya esta establecido de la ruta seleccionada 

      this.getRoutesByAddress((route) => {
        this.routes.push(route);
      });
    }
  }

  selectTargetCustomer () {
    if (this.customer && this.customerAddress) {
      this.travelLine.target_customer = this.customer.name;
      this.travelLine.target_customer_id = this.customer.id;
      this.travelLine.target_customer_address = this.customerAddress.name;
      this.travelLine.target_customer_address_id = this.customerAddress.id;
      this.getMarketPriceByRoute(); //Obtenemos el precio de mercado si es ya esta establecido de la ruta seleccionada 

      this.getRoutesByAddress((route) => {
        this.routes.push(route);
      });
    }
  }

  getRoutesByAddress(callback?:(route:TravelRoute) => void) : void {
    if(this.travelLine.source_customer_address_id && this.travelLine.target_customer_address_id && !this.travel.contracted) {
      this.loading = true;
      this.travelManager.getRoutesByAddresses(this.travelLine.source_customer_address_id, this.travelLine.target_customer_address_id, (routes) => {
  
        this.travelLine.gas = routes.length == 1 ? routes[0].gas : 0;
        this.travelLine.meters = routes.length == 1 ? routes[0].meters : 0;
        this.travelLine.time = routes.length == 1 ? routes[0].time : 0;
  
        if(routes.length == 1) {
          this.routes 
          this.hasRoute = true;
          if(callback) {
            callback(routes[0]);
          }
        } else {
          this.hasRoute = false;
          this.toastr.infoToastr("Ruta sin gastos, agregar manualmente");
        }
        
        this.loading = false;
  
      });
    }
  }

  selectProduct() {
    if (this.product) {
      this.travelLine.product_id = this.product.id;
      this.travelLine.product_name = this.product.name;

      if (this.travelLine.presentation_name == 'Cargas Diversas') {
        this.travelLine.presentation_id = 10;
        this.travelLine.presentation_name = "Vacio";
      }
    }
  }

  selectPresentation() {
    if (this.presentation) {
      this.travelLine.presentation_id = this.presentation.id;
      this.travelLine.presentation_name = this.presentation.name;
    }
  }

  changeCustomer() {
    this.customerAddress = this.customer.directions[0];
  }

  returnTravel() {
    let resp:boolean = false;

    if (this.travelLines[this.travelLines.length - 1].target_customer_address_id == this.travelLines[0].source_customer_address_id) {
      this.toastr.infoToastr('Ya existe un viaje de regreso!');
      return;
    }

    this.travelLine = {
      delivery_date: this.travelLines[this.travelLines.length - 1].delivery_date,
      gas: resp ? this.travelLines[0].gas : 0,
      meters: resp ? this.travelLines[0].meters : 0,
      ton: resp ? this.travelLines[0].ton : 0,
      travelExpenses: [],
      order_id: 0,
      presentation_id: this.presentations[Number(this.searchIndexPresentation('Vacio'))].id,
      presentation_name: this.presentations[Number(this.searchIndexPresentation('Vacio'))].name,
      product_id: this.products[Number(this.searchIndexProduct('Cargas Diversas'))].id,
      product_name: this.products[Number(this.searchIndexProduct('Cargas Diversas'))].name,
      source_customer: this.travelLines[this.travelLines.length - 1].target_customer,
      source_customer_id: this.travelLines[this.travelLines.length - 1].target_customer_id,
      source_customer_address: this.travelLines[this.travelLines.length - 1].target_customer_address,
      source_customer_address_id: this.travelLines[this.travelLines.length - 1].target_customer_address_id,
      target_customer: this.travelLines[0].source_customer,
      target_customer_id: this.travelLines[0].source_customer_id,
      target_customer_address: this.travelLines[0].source_customer_address,
      target_customer_address_id: this.travelLines[0].source_customer_address_id,
      time: resp ? this.travelLines[0].time : 0,
      unit_type_presentation: 'Sencillo',
      travel_id: 0,
      id: 0,
      line: this.travelLines.length,
      hasExpenses: false,
      gas_extra: 0,
      ticket: 0,
      ton_real: 0,
      num_lines: 1,
      market_price: this.travelLine.market_price
    };

    this.getRoutesByAddress((route) => {
      this.routes.push(route);
      this.travelLine.hasExpenses = true;
    });
  }

  searchIndexProduct(name:string){
    let index:number = 0;
    for(let i = 0; i < this.products.length; i++){
      if(this.products[i].name === name){
        index = i;
      }
    }
    return index;
  }

  searchIndexPresentation(name:string){
    let index = 0;
    for(let i = 0; i < this.presentations.length; i++){
      if(this.presentations[i].name === name){
        index = i;
      }
    }
    return index;
  }

  loadExpenses() {
    this.loading = true;
    this.expServ.getExpenses("type", "Viaje").then(expenses => {
      this.casetas = expenses.filter(exp => exp.expense_type.name == 'Casetas');
      this.caseta = this.casetas[0];
      this.loading = false;
    })
  }

  addExpense() {
    //verificar si ya existe ese gasto en los gastos de la linea
    let casetaExistente = this.selectedLine.travelExpenses.find(x => x.expense_id == this.caseta.id);

    if (casetaExistente) {
      this.toastr.infoToastr("El gasto ya existe actualmente!");
      return;
    }

    if(this.selectedLine && !this.selectedLine.hasExpenses) {
      let axi = this.caseta.axis.find(axi => axi.axis == this.totAxis);

      if (axi) {
        this.selectedLine.travelExpenses.push({
          axis: axi.axis,
          expense_id: this.caseta.id,
          expense_name: this.caseta.name,
          price: axi.price,
          quantity: 1,
          travel_id: 0,
          travel_line_id: 0,
          active: true,
          first: true,
          expense_type: this.caseta.expense_type.type,
          expense_type_name: this.caseta.expense_type.name,
          expense_type_id: this.caseta.expense_type.id,
          automatic: false,
        });

        this.cash += Number(axi.price);
      } else {
        this.selectedLine.travelExpenses.push({
          axis: this.totAxis,
          expense_id: this.caseta.id,
          expense_name: this.caseta.name,
          price: 0,
          quantity: 1,
          travel_id: 0,
          travel_line_id: 0,
          active: true,
          first: true,
          expense_type: this.caseta.expense_type.type,
          expense_type_name: this.caseta.expense_type.name,
          expense_type_id: this.caseta.expense_type.id,
          automatic: false,
        });

        this.cash += Number(axi.price);
      }
    } else {
      this.toastr.infoToastr("No puedes agregar gastos extras cuando ya haz definido una ruta predefinida en la sección de Rutas!");
    }
  }

  addComb() {
    //verificar si ya existe ese gasto en los gastos de la linea
    let combExistente = this.selectedLine.travelExpenses.find(x => x.expense_id == this.combustible.id);

    if (combExistente) {
      this.toastr.infoToastr("El gasto ya existe");
      return;
    }

    if(this.selectedLine && !this.selectedLine.hasExpenses) {
      this.selectedLine.travelExpenses.push({
        axis: 1,
        expense_id: this.combustible.id,
        expense_name: this.combustible.name,
        price: this.combustible.price,
        quantity: 1,
        travel_id: 0,
        travel_line_id: 0,
        active: true,
        first: true,
        expense_type: this.combustible.expense_type.type,
        expense_type_name: this.combustible.expense_type.name,
        expense_type_id: this.combustible.expense_type.id,
        automatic: false,
      });
    }
  }

  showMaps(mapsModal) {
    this.customers.forEach(customer => {
      customer.directions.forEach(address => {
        if (address.id == this.travelLine.source_customer_address_id) {
          this.origin.lat = Number(address.latitude);
          this.origin.lng = Number(address.longitude);
        }
      })
    });

    this.customers.forEach(customer => {
      customer.directions.forEach(address => {
        if (address.id == this.travelLine.target_customer_address_id) {
          this.target.lat = Number(address.latitude);
          this.target.lng = Number(address.longitude);
        }
      })
    });

    this.modalService.open(mapsModal, { size: 'lg' });
  }

  onChange(event) {
    this.travelLine.meters = this.utl.distanceStringToInt(event.routes[0].legs[0].distance.text);
    this.travelLine.time = this.utl.timeStringToInt(event.routes[0].legs[0].duration.text);
  }

  calcTotAxis() {
    this.setArrastresDisponibles();
    this.totAxis = 0;
    this.totAxis += this.travel.unity ? this.travel.unity.num_rims : 0;
    this.totAxis += this.travel.trailer_1 ? this.travel.trailer_1.num_rims : 0;
    // NOTE: Suma nuevamente num_rims de trailer 1 dos veces mas 
    this.totAxis += this.travel.trailer_2 ? this.travel.trailer_1.num_rims : 0;
    this.totAxis += this.travel.trailer_3 ? this.travel.trailer_1.num_rims : 0; 
  }

  //NOTE: Modifica Fecha
  // setDates(n: Number){
  //   switch(n){
  //     case 0: 
  //       this.travel.prd_loading_date = new Date(this.dtsMgr.calcProductDate(this.travel.delivery_date.getTime(), this.travelLines.map(x => x.time).reduce((x, y) => x + y, 0)));
  //       this.travel.gas_loading_date = new Date(this.dtsMgr.calcGasDate(this.travel.prd_loading_date.getTime()));        
  //     break;
  //     case 1:
  //       this.travel.gas_loading_date = new Date(this.dtsMgr.calcGasDate(this.travel.prd_loading_date.getTime()));
  //     break;
  //   }
  // }

  checkDates(){
    const delivery = this.combine(this.deliveryDate, this.deliveryTime);
    const prd = this.combine(this.prdDate, this.prdTime);
    const gas = this.combine(this.gasDate, this.gasTime);

    this.dateErrorMsg = '';

    if (gas==null || prd==null || delivery==null) {
      this.dateErrorMsg = 'Las fechas de carga de combustible, carga de producto y entrega son obligatorias';
    }else{
      // if (gas > delivery) this.dateErrorMsg = 'Fecha de carga de combustible no debe ser después de fecha de Entrega';
      if (gas > prd) this.dateErrorMsg = 'Fecha de carga de combustible no debe ser después de fecha de Producto';
      if (prd > delivery) this.dateErrorMsg = 'Fecha de carga de producto no debe ser después de fecha de Entrega';
    }

    if(this.dateErrorMsg != '') this.showError = true;
    else this.showError = false;

  }
  setInitDates(){
    const now = new Date();

    this.minDate = {
      year: now.getFullYear(),
      month: now.getMonth() + 1,
      day: now.getDate()
    };

    this.deliveryDate = { ...this.minDate };
    this.prdDate = { ...this.minDate };
    this.gasDate = { ...this.minDate };

    this.deliveryTime = {
      hour: now.getHours(),
      minute: now.getMinutes(),
      second: 0
    };

    this.prdTime = { ...this.deliveryTime };
    this.gasTime = { ...this.deliveryTime };
  }
  combine(date: NgbDateStruct, time: NgbTimeStruct): Date | null {
    if (!date || !time) return null;

    return new Date(
      date.year,
      date.month - 1, 
      date.day,
      time.hour,
      time.minute,
      time.second || 0
    );
  }
  handleSubmit(event, modal) {

    event.preventDefault(); 
    this.checkDates();

    if (this.showError) {
      this.pendingEvent = event;
      this.showModal(modal)
    } else {
      this.save(event);
    }
  }
  confirmSave(modal) {
    modal.close();

    if (this.pendingEvent) {
      this.save(this.pendingEvent);
      this.pendingEvent = null;
    }
  }
  setArrastres(unities){

    const allowedT1 = [3,4,2,7,6,5,23,24,25];
    const doubleAllowed = [2,5,7];

    this.arrastre1= unities.filter(item => 
      allowedT1.includes(item.unit_type_id) 
    );
    this.arrastre2 = unities.filter(item => 
      item.unit_type_id === 11
    );
    this.arrastre3 = unities.filter(item => 
      doubleAllowed.includes(item.unit_type_id) 
    );
    this.arrastre3B = this.arrastre3; 
  }
  setArrastresDisponibles(){
    const doubleAllowed = [2,5,7];

    this.arrastre1Disabled = !(this.travel.unity && this.travel.unity.unit_type_id == 1);
    if(this.travel.trailer_1 && doubleAllowed.includes(this.travel.trailer_1.unit_type_id)){
      this.arrastre2Disabled = false;
      this.arrastre3 = this.arrastre3B.filter(item => 
        this.travel.trailer_1.unit_type_id === item.unit_type_id 
        && this.travel.trailer_1.id !== item.id 
      );
      if(this.travel.trailer_3)
        if(!this.arrastre3.some(item => item.id == this.travel.trailer_3.id))
          this.travel.trailer_3 = null;
    } else{
      this.arrastre2Disabled = true;
      this.arrastre3Disabled = true;
      this.travel.trailer_2 = null;
      this.travel.trailer_3 = null;
    } 

    if(this.travel.trailer_2){
      this.arrastre3Disabled = false;
    }else{
      this.arrastre3Disabled = true;
      this.travel.trailer_3 = null;
    }
  }
  // setArrastresDisponibles(){
  //   const doubleAllowed = [2,5,7];

  //   if(this.travel.unity){
  //     if (this.travel.unity.unit_type_id == 1) {
  //       this.arrastre1Disabled = false; 
  //     }
  //   }
  //   if(this.travel.trailer_1){
  //     if(doubleAllowed.includes(this.travel.trailer_1.unit_type_id)){
  //       this.arrastre2Disabled = false;
  //       this.arrastre3 = this.arrastre3B.filter(item => 
  //         this.travel.trailer_1.unit_type_id === item.unit_type_id 
  //         && this.travel.trailer_1.id !== item.id 
  //       );
  //       if(this.travel.trailer_3)
  //         if(!this.arrastre3.some(item => item.id == this.travel.trailer_3.id))
  //           this.travel.trailer_3 = null;
  //     }else{
  //       this.arrastre2Disabled = true;
  //       this.travel.trailer_2 = null;
  //       this.travel.trailer_3 = null;
  //     }
  //   } else{
  //     this.arrastre2Disabled = true;
  //     this.arrastre3Disabled = true;
  //     this.travel.trailer_2 = null;
  //     this.travel.trailer_3 = null;
  //   } 

  //   if(this.travel.trailer_2){
  //     this.arrastre3Disabled = false;
  //   }else{
  //     this.arrastre3Disabled = true;
  //     this.travel.trailer_3 = null;
  //   }
  // }
  verifArrastres():[boolean, string]{
    const t2 = this.travel.trailer_2 ? this.travel.trailer_2 : null; 
    const t3 = this.travel.trailer_3 ? this.travel.trailer_3 : null; 

    if (t2) {
      if (!t3) 
        return [true, 'Debe haber arrastre 3'];
    }
    return [false,''];
  }
  getMarketPriceByRoute(){
    this.travelServ.getTravelRoutesById(this.travelLine.source_customer_id, this.travelLine.source_customer_address_id, this.travelLine.target_customer_id, this.travelLine.target_customer_address_id).then(response => {
      this.travelRoutes = response;
      this.travelLine.market_price = this.travelRoutes.length > 0 ? this.travelRoutes[0].market_price : 0;
    }, error => {
      this.travelLine.market_price = 0; //Si ocurre un error al obtener la ruta, ponemos cero en el campo del precio de mercado
    });
  }
}
